import React from 'react'
import ParentSubScoreItem from './ParentSubScoreItem'
import { useTranslation } from 'react-i18next'
import './ParentSubScoreList.scss'

const ParentSubScoreList = ({ studentName, subscores, i18n }) => {
  const { t } = useTranslation(['teacher_parent_report'], {i18n})

  if(!subscores) return null

  return (
    <div className="parent-subscore-list-container">
      <h3>{t('{{name}}\'s Reading Subscores', {name: studentName, interpolation: { escapeValue: false },})}</h3>
      <div className="parent-subscore-list">
        <ParentSubScoreItem i18n={i18n} name={t('Decoding')} values={subscores.decoding}/>
        <ParentSubScoreItem i18n={i18n} name={t('Phonological Awareness')} values={subscores.phonologicalAwareness}/>
        <ParentSubScoreItem i18n={i18n} name={t('High Frequency Words')} values={subscores.highFrequencyWords}/>
        <ParentSubScoreItem i18n={i18n} name={t('Background Knowledge')} values={subscores.backgroundKnowledge}/>
        <ParentSubScoreItem i18n={i18n} name={t('Structure and Reasoning')} values={subscores.structureAndReasoning}/>
        <ParentSubScoreItem i18n={i18n} name={t('Vocabulary')} values={subscores.vocabulary}/>
      </div>
    </div>
  )
}

export default ParentSubScoreList